
import getPixels from "get-pixels";
import { NdArray } from "ndarray";
import { logger } from "../../core/services/LogService";
import StatisticIndicatorLegendColorCase from "../models/StatisticIndicatorLegendColorCase";
import StatisticIndicatorModel from "../models/StatisticIndicatorModel";
import StatisticIndicatorType from "../models/StatisticIndicatorType";

export const DEFAULT_LEGEND_LEVELS_COUNT = 12;
export const buildIndicatorLegend = async (statisticIndicator: StatisticIndicatorModel): Promise<{ indicatorType: StatisticIndicatorType, legends: StatisticIndicatorLegendColorCase[] }> => {

    return new Promise<{ indicatorType: StatisticIndicatorType, legends: StatisticIndicatorLegendColorCase[] }>(function (resolve, reject) {
        if (statisticIndicator.legend_url && statisticIndicator.max !== undefined && statisticIndicator.min !== undefined) {
            const legendColorCases: StatisticIndicatorLegendColorCase[] = [];
            getPixels(statisticIndicator.legend_url, (err: Error | null, pixels: NdArray<Uint8Array>) => {
                if (err) {
                    logger.error(`Error reading legend image ${statisticIndicator.legend_url}`)
                    reject(err)
                    return
                }
                logger.debug(`got pixels for legend ${statisticIndicator.legend_url}`, pixels.shape.slice());
                const levelCount = Math.min(pixels.shape[0], statisticIndicator.legend_levels_count ?? DEFAULT_LEGEND_LEVELS_COUNT);
                const levelStep = Math.floor(pixels.shape[0] / levelCount);
                const initPos = Math.floor(levelStep / 2);
                const scaleStep = (statisticIndicator.max! - statisticIndicator.min!) / levelCount;
                let initVal = statisticIndicator.min!;
                const middleLineIndex = Math.floor(pixels.shape[1] / 2);
                // Loop on first line
                let iLevel = 0;
                for (let i = initPos; i < pixels.shape[0]; i += levelStep) {
                    const colorValue = rgbToHex(pixels.get(i, middleLineIndex, 0), pixels.get(i, middleLineIndex, 1), pixels.get(i, middleLineIndex, 2))
                    //console.log(colorValue);
                    const levelName = `${initVal} - ${initVal + scaleStep}`;
                    const legendColorCase: StatisticIndicatorLegendColorCase = {
                        color: colorValue,
                        min: initVal,
                        max: initVal + scaleStep,
                        level: levelName,
                        max_inclusive: iLevel === levelCount - 1
                    }
                    legendColorCases.push(legendColorCase);
                    iLevel++;
                    initVal += scaleStep;
                }
                statisticIndicator.legend = legendColorCases;

                resolve({ indicatorType: statisticIndicator.ref, legends: legendColorCases })
            });
        } else {
            reject(`Cannot build legend for indicator ${statisticIndicator.ref}`)
        }
    });
}

export const rgbToHex = (pixelR: number, pixelG: number, pixelB: number) => {
    const componentToHex = (c: number) => {
        const hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    };

    return (
        "#" +
        componentToHex(pixelR) +
        componentToHex(pixelG) +
        componentToHex(pixelB)
    ).toUpperCase();
};